//@ts-check
import { G, Rect, Svg, Text } from '@react-pdf/renderer';
import jsbarcode from 'jsbarcode';
import React from 'react';
import xml2js from 'xml2js';
import { Box } from '.';
import { DOMImplementation, XMLSerializer } from 'xmldom';

export default function Barcode({ value, width, height, style }) {
  const [barcode, setBarcode] = React.useState({
    g: [],
    viewBox: '',
    svg: '',
  });
  if (!value) return null;
  if (barcode.g.length > 0) {
    return (
      <Svg viewBox={barcode.viewBox} style={{ width, height }}>
        <Rect x="0" y="0" style={{ fill: '#ffffff' }} />
        <G
          style={{
            transform: barcode.g[0].$.transform,
            fill: '#000000',
            stroke: '#000000',
          }}
        >
          {barcode.g[0].rect.map((rect, index) => (
            <Rect key={`rect_${index}`} {...rect.$} />
          ))}

          <Text
            style={{ font: '20px monospace', textAnchor: 'middle' }}
            x={barcode.g[0].text[0].$.x}
            y={barcode.g[0].text[0].$.y}
          >
            {barcode.g[0].text[0]._}
          </Text>
        </G>
      </Svg>
    );
  }
  const xmlSerializer = new XMLSerializer();
  const document = new DOMImplementation().createDocument(
    'http://www.w3.org/1999/xhtml',
    'html',
    null
  );
  const svgNode = document.createElementNS('http://www.w3.org/2000/svg', 'svg');

  jsbarcode(svgNode, value, {
    xmlDocument: document,
    flat: true,
  });

  const svgText = xmlSerializer.serializeToString(svgNode);
  xml2js.parseStringPromise(svgText).then((data) => {
    setBarcode({
      svg: svgText,
      viewBox: data.svg.$.viewBox,
      // Barcode
      g: data.svg.g,
    });
  });
  return <Box style={style} />;
}
